'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeRenewCheckoutEvent = composeRenewCheckoutEvent;
exports.composeDigitalCheckoutEvent = composeDigitalCheckoutEvent;
exports.composeReturnEvent = composeReturnEvent;
exports.composeDownloadEvent = composeDownloadEvent;
exports.composeReadInBrowserEvent = composeReadInBrowserEvent;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

var _getLabelForProvider = require('./getLabelForProvider');

var _getLabelForProvider2 = _interopRequireDefault(_getLabelForProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENTS = _constantsAnalytics2.default.EVENTS,
    CATEGORIES = _constantsAnalytics2.default.CATEGORIES,
    ACTIONS = _constantsAnalytics2.default.ACTIONS,
    CUSTOM_DIMENSIONS = _constantsAnalytics2.default.CUSTOM_DIMENSIONS;


function composeCheckoutsEvent(_ref) {
  var event = _ref.event,
      gtmAction = _ref.gtmAction,
      gtmValue = _ref.gtmValue,
      gtmLabel = _ref.gtmLabel;

  return (0, _compose.composeEvent)(event, {
    gtmCategory: CATEGORIES.CHECKOUTS,
    gtmAction: gtmAction,
    gtmLabel: gtmLabel,
    gtmValue: gtmValue,
    gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ITEM
  });
}

function composeRenewCheckoutEvent(_ref2) {
  var checkoutIds = _ref2.checkoutIds;

  return (0, _compose.composeAnalytics)([composeCheckoutsEvent({
    event: EVENTS.RENEW_CHECKOUT,
    gtmAction: ACTIONS.RENEW_ITEM,
    gtmValue: checkoutIds.length
  })]);
}

function composeDigitalCheckoutEvent(_ref3) {
  var provider = _ref3.provider;

  return (0, _compose.composeAnalytics)([composeCheckoutsEvent({
    event: EVENTS.DIGITAL_CHECKOUT,
    gtmAction: ACTIONS.PLACE,
    gtmValue: 1,
    gtmLabel: (0, _getLabelForProvider2.default)(provider)
  })]);
}

function composeReturnEvent(_ref4) {
  var provider = _ref4.provider;

  return (0, _compose.composeAnalytics)([composeCheckoutsEvent({
    event: EVENTS.RETURN_CHEKOUT,
    gtmAction: ACTIONS.RETURN,
    gtmValue: 1,
    gtmLabel: (0, _getLabelForProvider2.default)(provider)
  })]);
}

function composeDownloadEvent(_ref5) {
  var provider = _ref5.provider;

  return (0, _compose.composeAnalytics)([composeCheckoutsEvent({
    event: EVENTS.DOWNLOAD_CHECKOUT,
    gtmAction: ACTIONS.DOWNLOAD,
    gtmValue: 1,
    gtmLabel: (0, _getLabelForProvider2.default)(provider)
  })]);
}

function composeReadInBrowserEvent(_ref6) {
  var provider = _ref6.provider;

  return (0, _compose.composeAnalytics)([composeCheckoutsEvent({
    event: EVENTS.READ_CHECKOUT_IN_BROWSER,
    gtmAction: ACTIONS.READ,
    gtmValue: 1,
    gtmLabel: (0, _getLabelForProvider2.default)(provider)
  })]);
}

exports.default = {
  composeRenewCheckoutEvent: composeRenewCheckoutEvent,
  composeDigitalCheckoutEvent: composeDigitalCheckoutEvent,
  composeReturnEvent: composeReturnEvent,
  composeDownloadEvent: composeDownloadEvent,
  composeReadInBrowserEvent: composeReadInBrowserEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/checkoutsEventComposer.js
// module id = 577
// module chunks = 0 2 4 5 6 8 9 10 11